const CODES_RAPPROCHEMENT_MANUEL = new Set([
  "9-21845",
  "9-26228",
  "9-44153"
]);

export function rapprochementAutomatiqueAutorise(codeClient) {
  return !CODES_RAPPROCHEMENT_MANUEL.has(String(codeClient || "").trim());
}

export function preparerMappingInterclub({ client, clubId = null, clubs = [], groupe = "" }) {
  const codeClient = String(client?.code_client || "").trim();
  const groupeNormalise = String(groupe || "").trim();
  if (!codeClient) throw new Error("Code client Interclub manquant.");
  if (!groupeNormalise) throw new Error("Groupe du Club manquant.");

  const idCible = clubId == null ? "" : String(clubId);
  const cible = idCible
    ? clubs.find((club) => String(club?.id || club?.identifiant || "") === idCible)
    : null;
  if (idCible && !cible) throw new Error("Club cible introuvable dans le groupe courant.");

  const codeNormalise = codeClient.toUpperCase();
  const dejaRattaches = clubs.filter((club) => (
    String(club?.numero_compte_interclub || "").trim().toUpperCase() === codeNormalise
    && String(club?.id || club?.identifiant || "") !== idCible
  ));
  if (dejaRattaches.length > 0) {
    throw new Error(`Mapping ambigu : le compte ${codeClient} est déjà rattaché à un autre Club.`);
  }

  const codeCible = String(cible?.numero_compte_interclub || "").trim();
  if (cible && codeCible && codeCible.toUpperCase() !== codeNormalise) {
    throw new Error(`Mapping ambigu : le Club ${cible.nom || cible.code || idCible} possède déjà le compte ${codeCible}.`);
  }

  return { codeClient, groupe: groupeNormalise, club: cible };
}

export { CODES_RAPPROCHEMENT_MANUEL };
